module.exports = __webpack_public_path__ + "img/message-tick.ee7d47fd.svg";